import BusinessIcon from '@mui/icons-material/Business';
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';
import Diversity1Icon from '@mui/icons-material/Diversity1';
const styles = { marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }

export const danos = [
    {
        description: "Danos humanos:",
        icon: <Diversity1Icon style={styles} />,
        bubles: [
            {
                label: "Primeiros socorros",
                value: "1"
            },
            {
                label: "Tratamento médico",
                value: "2"
            },
            {
                label: "Tempo de serviço perdido",
                value: "3"
            },
            {
                label: "Evacuação",
                value: "4"
            },
            {
                label: "Ferimento sério",
                value: "5"
            }
        ]
    },
    {
        description: "Danos materiais:",
        icon: <BusinessIcon style={styles} />,
        bubles: [
            {
                label: "Danos ao equipamento",
                value: "6"
            },
            {
                label: "Danos a propriedade",
                value: "7"
            },
            {
                label: "Perda do produto",
                value: "8"
            },
            {
                label: "Contaminação do produto",
                value: "9"
            }
        ]
    },
    {
        description: "Danos ambientais/outros:",
        icon: <EmojiNatureIcon style={styles} />,
        bubles: [
            {
                label: "Solos",
                value: "11"
            },
            {
                label: "Água",
                value: "12"
            },
            {
                label: "Ar",
                value: "13"
            },
            {
                label: "Incêndio",
                value: "14"
            },
            {
                label: "Vandalismo/Intrusão",
                value: "15"
            }
        ]
    }
]

export const toMakeReportsCtegories = [
    {
        description: "Danos humanos:",
        sectionId: "1",
        rules: [1, 2, 3, 4, 5]
    },
    {
        description: "Danos materiais:",
        sectionId: "2",
        rules: [6, 7, 8, 9]
    },
    {
        description: "Danos ambientais/outros:",
        sectionId: "3",
        rules: [11, 12, 13, 14, 15]
    }
]
